import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { updateNotificationTemplate } from "../../api/apiNotificationTemplates";
import parseError from "../../utils/parseError";

export const useUpdateNotificationTemplate = () => {
    const queryClient = useQueryClient();

    const { mutate: updateTemplateMutate, mutateAsync: updateTemplateAsync, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updateNotificationTemplate(id, data),
        onSuccess: (res, variables) => {
            toast.success(res?.message || "Template updated successfully");
            queryClient.invalidateQueries({ queryKey: ["notification-templates"] });
            if (variables?.id) {
                queryClient.invalidateQueries({ queryKey: ["notification-template", variables.id] });
            }
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to update template");
        },
    });

    return { updateTemplateMutate, updateTemplateAsync, isUpdating };
};
